<template>
    <div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="logisComList" :data="logisComList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" align="center" width="55"></el-table-column>
                    <el-table-column prop="logisComCode" label="公司代码" align="center"></el-table-column>
                    <el-table-column prop="logisComName" label="公司名称" align="center"></el-table-column>
                </el-table>
            </div>
            <div v-else class="table-layout">
                <el-table :data="logisComList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checlLogisComInfo!= null && checlLogisComInfo.logisComId == rows.row.logisComId}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="logisComCode" label="公司代码" align="center"></el-table-column>
                    <el-table-column prop="logisComName" label="公司名称" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import merchtLogisApi from '../../api/merchtLogis'

    export default {
        name: 'swb-merchant-logis-com-list-for-select',
        desc: '物流公司-选择(发货单使用)',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),

                logisComList: [],
                selectLogisComList: [],
                checlLogisComInfo: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            let selectIds = this.selectIds || [];
            if(selectIds.length > 0) {
                if(Utils.isTrue(this.checkBox)) {
                    let selectLogisComList = [];
                    for(let i = 0; i < selectIds.length; i++) {
                        let selectId = selectIds[i];
                        let item = {
                            logisComId: selectId
                        };
                        selectLogisComList.push(item);
                    }
                    this.selectLogisComList = Utils.merge([], selectLogisComList);
                } else {
                    let checlLogisComInfo = {
                        logisComId: selectIds[0]
                    };
                    this.checlLogisComInfo = Utils.merge({}, checlLogisComInfo);
                }
            }
            //
            this.getLogisComPageList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getLogisComPageList();
            },
            getLogisComPageList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = self.filter;
                merchtLogisApi.getMerchantLogisComList(postData, function (result) {
                    if(result.type == "info") {
                        let logisComList = result.data.rows;
                        self.logisComList = logisComList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            selectable: function (row, index) {
                let selectIds = this.selectIds;
                if(selectIds.indexOf(row.logisComId) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectLogisComList = val;
            },
            handleCurrentChange: function (val) {
                this.checlLogisComInfo = Utils.merge({}, val);
            },

            getLogisComList: function () {
                let logisComList = [];
                logisComList = this.selectLogisComList;
                return logisComList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let logisComList = self.selectLogisComList;
                    if(logisComList != null && logisComList.length > 0) {
                        result.type = "info";
                        result.data = self.getLogisComList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个商品！';
                    }
                } else {
                    let checlLogisComInfo = self.checlLogisComInfo;
                    if(checlLogisComInfo != null) {
                        if(Utils.isNoB(checlLogisComInfo.id) && !Utils.isNoB(checlLogisComInfo.logisComId)) {
                            let logisComList = self.logisComList || [];
                            for(let i = 0; i < logisComList.length; i++) {
                                let logisCom = logisComList[i];
                                if(logisCom.logisComId == checlLogisComInfo.logisComId) {
                                    checlLogisComInfo = logisCom;
                                    break;
                                }
                            }
                        }
                        result.type = "info";
                        result.data = checlLogisComInfo;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个商品！';
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchtLogis/MerchantLogisComListForSelect.vue